import React from "react";
import { SelectedCircleOverlapPlayerAvatars } from "../selectedCircleOverlapPlayerAvatars/SelectedCircleOverlapPlayerAvatars";
import { TCText } from "../TCText/TCText";
import { observer } from "mobx-react-lite";
import { useSelectCircleStore } from "../../stores/StoreContext";

type props = {};

export const ExcludedPlayersInCollapsed: React.FC<props> = observer(() => {
  const selectCircleStore = useSelectCircleStore();
  return selectCircleStore.excludedPlayers.length ? (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
      }}>
      <div>
        <TCText
          value={`${selectCircleStore.excludedPlayers.length} excluded players`}
          style={{ fontWeight: 500, fontSize: 10, color: "white" }}
        />
      </div>
      <SelectedCircleOverlapPlayerAvatars
        list={selectCircleStore.excludedPlayers.flatMap((player) => ({
          image: player.userImageUrl,
          name: player.name,
        }))}
      />
    </div>
  ) : null;
});
